import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from "@angular/material/tabs";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { BehaviorSubject, combineLatest } from "rxjs";
import { filter } from "rxjs/operators";
import { SocialService } from "src/app/services/social.service";
import { IonicModule } from "@ionic/angular";
import { NgClass, AsyncPipe } from "@angular/common";
import { InProgressAnimationComponent } from "../../../in-progress-animation/in-progress-animation.component";

@Component({
    selector: "app-games-leaderboard",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./games-leaderboard.component.html",
    styleUrls: ["./games-leaderboard.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        MatTabGroup,
        MatTab,
        MatTabLabel,
        NgClass,
        InProgressAnimationComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class GamesLeaderboardComponent implements OnInit {
  getUserGameDiscoveryDetails$ = new BehaviorSubject(null);
  getHallOfFame$ = new BehaviorSubject(null);
  getLeaderPlayerWeek$ = new BehaviorSubject(null);
  leaderPlayerMonth$ = new BehaviorSubject(null);
  selectedLanguage: string;
  previous: Data;
  previousMonth: Data;
  previousWeek: Data;
  public currentSection: number;
  constructor(
    private socialService: SocialService,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.socialService.getDataLeader$.subscribe();
    this.currentSection = 0;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit(): void {
    this.socialService?.leaderBoardData$?.subscribe((d) => {
      if (d) {
        this.leaderPlayerMonth$.next(d[0]);
        this.getLeaderPlayerWeek$.next(d[1]);
        this.getHallOfFame$.next(d[2]);
      }
    });

    const combinedData$ = combineLatest(this.leaderPlayerMonth$, this.getLeaderPlayerWeek$, this.getHallOfFame$).pipe(
      filter(([monthData, weekData, fameData]) => monthData != null && weekData != null && fameData != null)
    );

    combinedData$.subscribe(([monthData, weekData, fameData]) => {
      this.previousMonth = monthData?.previous_list;
      this.previousWeek = weekData?.previous_list;
      this.previous = fameData?.previous_list;
    });
  }
  // This method is used to get the date difference
  getDateDifference(listOne) {
    if (!listOne) return "";

    if (this.previous !== undefined) {
      const current = this.previous?.find((e) => e?.wp_user_id === listOne.wp_user_id)?.gxp;

      if (!current) return "";

      if (listOne.gxp >= current) {
        return "../../../../assets/icon/green-Arrow.svg";
      } else {
        return "../../../../assets/icon/Read-Arrow.svg";
      }
    }
  }
  // This method is used to get the Month count
  getMonthCount(listOne) {
    if (!listOne) return "";

    if (this.previousMonth !== undefined) {
      const current = this.previousMonth?.find((e) => e?.wp_user_id === listOne.wp_user_id)?.gxp;

      if (!current) return "";

      if (listOne.gxp >= current) {
        return "../../../../assets/icon/green-Arrow.svg";
      } else {
        return "../../../../assets/icon/Read-Arrow.svg";
      }
    }
  }
  // This method is used to get the week count
  getWeekCount(listOne) {
    if (!listOne) return "";

    if (this.previousWeek !== undefined) {
      const current = this.previousWeek?.find((e) => e?.wp_user_id === listOne.wp_user_id)?.gxp;

      if (!current) return "";

      if (listOne.gxp >= current) {
        return "../../../../assets/icon/green-Arrow.svg";
      } else {
        return "../../../../assets/icon/Read-Arrow.svg";
      }
    }
  }
  // This method is used to get the rank from the list
  async getRank(data) {
    if (data !== null) {
      const userId = parseInt(localStorage.getItem("wp_user_id"));
      if (Number.isNaN(userId)) {
        try {
          const translation = await this.translate.get("missions.current_ranking").toPromise();
          return { success: false, code: 'INVALID_USER_ID', message: translation };
        } catch (err) {
          console.error(err);
          return { success: false, code: 'TRANSLATION_ERROR', message: err.message };
        }
      }
      const sortedData = data.sort((a, b) => b.gxp - a.gxp);
      const userIndex = sortedData.findIndex((d) => d?.wp_user_id === userId);
      if (userIndex < 0) {
        try {
          const translation = await this.translate.get("missions.current_ranking").toPromise();
          return { success: false, code: 'USER_NOT_FOUND', message: translation };
        } catch (err) {
          console.error(err);
          return { success: false, code: 'TRANSLATION_ERROR', message: err.message };
        }
      }
      return { success: true, rank: userIndex + 1 };
    } else {
      return { success: false, code: 'DOCUMENT_NOT_FOUND', message: 'Document does not exist' };
    }
  }


  tabChanged = (tabChangeEvent: MatTabChangeEvent) => {
    if (tabChangeEvent != null) {
      this.currentSection = tabChangeEvent?.index;
    }
  };
}
